import { Component, Inject, Input, NgModuleRef, OnInit } from '@angular/core';
import { RbacPermissionsConstant } from '../../services/rbac/rbac-permissions.constant';
import { IMODALS_SERVICE, IModalsService } from '@platform500services/p500-ui-kit';
import { NetworkTermsComponent } from '../../modals/network-terms/network-terms.component';
import { IMetricsService } from '../../../modules/settings/crm-metrics/services/metrics-service.interface';
import { DestroySubscribers } from '../../decorators/destroy-subscribers.decorator';
import { formatLocalization } from '../base-metric-card/helpers/base-metrics.helpers';
import { CardData } from '../base-metric-card/base-metric-card.component';

@Component({
  selector: 'gtd-network-metric-card',
  templateUrl: './network-metric-card.component.html',
})
@DestroySubscribers()
export class NetworkMetricCardComponent implements OnInit {
  @Input() public row: CardData;
  @Input() public viewOnly: boolean;
  public metrics: { id: number; name: string }[];
  public RbacPermissionsConstant = RbacPermissionsConstant;
  public isLoading: boolean = true;
  public formatLocalization = formatLocalization;

  private subscribers: any = {};

  constructor(
    @Inject(IMODALS_SERVICE) public modalService: IModalsService,
    @Inject('IMetricsService') private metricsService: IMetricsService,
    private ngRef: NgModuleRef<any>
  ) {}

  ngOnInit(): void {
    this.subscribers.metrics = this.metricsService.getBaseMetrics().subscribe((data) => {
      this.metrics = data;
      this.isLoading = false;
    });
  }

  edit(id: number) {
    this.modalService.open(NetworkTermsComponent, { id }, this.ngRef);
  }
}
